import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c26a583a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-preview-box" }
const _hoisted_2 = { class: "modal-mask" }
const _hoisted_3 = { class: "modal-wrapper" }
const _hoisted_4 = { style: {"display":"flex","justify-content":"space-between","align-items":"center","width":"calc(100vw - 100px)"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "File Name: ", -1))
const _hoisted_6 = { class: "file-name" }
const _hoisted_7 = {
  key: 0,
  class: "modal-body hide-scroll"
}
const _hoisted_8 = ["type", "src"]
const _hoisted_9 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_10 = { class: "imagePreview" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "modal-body"
}
const _hoisted_13 = { class: "body-wrapper" }
const _hoisted_14 = {
  key: 3,
  class: "modal-body"
}
const _hoisted_15 = { class: "body-wrapper" }
const _hoisted_16 = {
  key: 0,
  class: "loading-wrapper"
}
const _hoisted_17 = {
  key: 1,
  class: "error-wrapper"
}

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(['modal-container', _ctx.viewMode == 3 || _ctx.showDownloadButton || _ctx.state == 3 ? 'alertbox-size' : ''])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(['modal-header', _ctx.viewMode == 3 || _ctx.showDownloadButton || _ctx.state == 3 ? 'alertbox-size' : ''])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("small", null, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.viewingFile.FileName ? _ctx.viewingFile.FileName : '---'), 1)
              ]),
              (!(_ctx.viewMode === 3 || _ctx.showDownloadButton) && _ctx.viewMode !== -1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-default sml",
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.download && _ctx.download(...args)))
                  }, " Download this file "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("i", {
                class: "close-button far fa-times-circle close-icon fa-2x",
                onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.$emit('closeFilePreview')), ["stop"]))
              })
            ])
          ], 2),
          (_ctx.viewMode === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("iframe", {
                  class: "previewPDF",
                  type: _ctx.previewFile.ContentType,
                  width: "100%",
                  src: _ctx.documentURL
                }, null, 8, _hoisted_8)
              ]))
            : (_ctx.viewMode === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", { src: _ctx.documentURL }, null, 8, _hoisted_11)
                  ])
                ]))
              : ((_ctx.viewMode === 3 || _ctx.showDownloadButton) && _ctx.state == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        class: "btn btn-tertiary mt-4",
                        onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.download && _ctx.download(...args)))
                      }, "Download this file")
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      (_ctx.state == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_LoadingIndicator)
                          ]))
                        : (_ctx.state == 3)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_component_ErrorIndicator)
                            ]))
                          : _createCommentVNode("", true)
                    ])
                  ]))
        ], 2)
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.showPreview]
  ])
}